/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section1_P1Inputs */

const en_privacy_section1_p1 = /** @type {(inputs: Privacy_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is built with a privacy-first approach. All JSON processing happens entirely in your browser. No data is ever sent to, stored on, or processed by any server. Your JSON data never leaves your device.`)
};

const ko_privacy_section1_p1 = /** @type {(inputs: Privacy_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 프라이버시 우선 방식으로 구축되었습니다. 모든 JSON 처리는 사용자의 브라우저에서 완전히 이루어집니다. 어떤 데이터도 서버로 전송, 저장 또는 처리되지 않습니다. JSON 데이터는 절대 사용자의 기기를 벗어나지 않습니다.`)
};

const ja_privacy_section1_p1 = /** @type {(inputs: Privacy_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONはプライバシーファーストのアプローチで構築されています。すべてのJSON処理はブラウザ内で完全に行われます。データがサーバーに送信、保存、処理されることはありません。JSONデータはデバイスを離れることはありません。`)
};

/**
* | output |
* | --- |
* | "PureJSON is built with a privacy-first approach. All JSON processing happens entirely in your browser. No data is ever sent to, stored on, or processed by an..." |
*
* @param {Privacy_Section1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section1_p1 = /** @type {((inputs?: Privacy_Section1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section1_p1(inputs)
	if (locale === "ko") return ko_privacy_section1_p1(inputs)
	return ja_privacy_section1_p1(inputs)
});